import { ISnapIv } from './isnapiv';

export interface ISnapIvState {
    snapIv: ISnapIv;
    snapIvs: ISnapIv[];
    id: string;
    error?: any;
}
